import React from 'react';
import { connect } from 'react-redux';

import { Accordion } from 'components/no-auth/common/accordion/Accordion';
import styles from 'components/no-auth/common/accordion/Accordion.module.css';
import { BackToTopButton } from 'components/no-auth/common/back-to-top-button/BackToTopButton';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';
import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { CommonSection } from 'components/no-auth/common/sections/styles';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';
import RuleItem from 'components/no-auth/rules/RuleItem';

import { FlagIcon } from '../components/common/FlagIcon/FlagIcon';

const RulesPage = (props) => {
    const getItems = () => {
        return props.countriesList.map((c) => {
            const rules = props.rulesData.find((r) => r.id === c.dataId);
            return {
                header: (
                    <div className={styles.accordionHeaderContent}>
                        {c.code_a2 && (
                            <div className={styles.accordionFlag}>
                                <FlagIcon name={`${c.code_a2.toLowerCase()}`} size={'24px'} />
                            </div>
                        )}
                        {c.name && (
                            <PromoText color={'baseColor'} tag={'span'}>
                                {c.name}
                            </PromoText>
                        )}
                    </div>
                ),
                content: <RuleItem rules={rules} />,
            };
        });
    };

    return (
        <PromoPageContainer bgColor="eggshell03" hasTopPadding>
            <PromoSectionContainer>
                {props.pageTitle && <HeadingSection title={props.pageTitle} titleTag={'h1'} />}
                {Array.isArray(props.countriesList) && Array.isArray(props.rulesData) && (
                    <CommonSection>
                        <Accordion items={getItems()} />
                    </CommonSection>
                )}
                {props.backToTopBtn && <BackToTopButton caption={props.backToTopBtn} />}
            </PromoSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        pageTitle: state.extra?.strapiApi?.page_title?.title,
        countriesList: state.extra?.strapiApi?.countries_list,
        rulesData: state.extra?.strapiApi?.termsAndConditions,
        backToTopBtn: state.extra?.strapiApi?.page_title?.backToTopBtn,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(RulesPage));
